export default __webpack_public_path__ + "static/media/171.22caf1ec.jpg";